import { EditOutline18Icon } from "@vygruppen/spor-icon-react";
import { ProductionDeviationForm } from "features/CenterContent/RoleContent/ProductionDeviation/types/formSchema";
import { useProductionDeviationPath } from "features/CenterContent/RoleContent/ProductionDeviation/utils";
import { OperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { filterOpInfoTypesTrain } from "features/CenterContent/shared/operationalInformation/utils";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HStack, IconButton, VStack } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import { ddMMyy } from "shared/utils/dateUtils";

type FormInputsHeaderProps = {
  trainSeries: string[];
  trainSeriesIndex: number;
  opInfoData: OperationalInformationTypes;
  toFormInputsStep: () => void;
};

export const FormInputsHeader: FC<FormInputsHeaderProps> = ({
  trainSeries,
  trainSeriesIndex,
  opInfoData,
  toFormInputsStep,
}) => {
  const { t } = useTranslation();
  const trainSerie = trainSeries[trainSeriesIndex];
  const { path } = useProductionDeviationPath(trainSerie);
  const { watch } = useFormContext<ProductionDeviationForm>();
  const trainFormPath = "batchTrainForm.0.trainForm" as const;
  const durations = watch("durations");
  const event = watch(path(`${trainFormPath}.type`)) as string;
  const reason = watch(path(`${trainFormPath}.reason.type`));
  const action = watch(path(`${trainFormPath}.action.type`));
  const { events, reasons, actions } = filterOpInfoTypesTrain(opInfoData);
  const formInputs = [
    {
      formInput: t("Hendelse", { count: 1 }),
      label: events.find((it) => it.type === event)?.label,
    },
    {
      formInput: t("Årsak"),
      label: reasons.find((it) => it.type === reason)?.label,
    },
    {
      formInput: t("Handling"),
      label:
        actions.find((it) => it.type === action)?.label ??
        t("Ingen handling valgt"),
    },
  ];
  return (
    <HStack>
      <VStack alignItems="start" flex={1}>
        <Text secondary>{t("Tidsperiode")}:</Text>
        <Text bold>
          {ddMMyy(durations.from_time)} - {ddMMyy(durations.to_time)}
        </Text>
      </VStack>
      {formInputs.map(({ formInput, label }) => (
        <VStack alignItems="start" flex={1} key={formInput}>
          <Text secondary>{formInput}:</Text>
          <Text bold>{label}</Text>
        </VStack>
      ))}
      <IconButton
        my="auto"
        onClick={toFormInputsStep}
        size="xs"
        aria-label={t("Rediger")}
        variant="tertiary"
        icon={<EditOutline18Icon />}
      />
    </HStack>
  );
};
